<div class="component-page-header"></div>

  <mat-card class="mt-4">
    <app-article-header>
      <mat-card-title>
        <span>OverView</span>
      </mat-card-title>
    </app-article-header>

        <div class="main-title">
          <h1>My Courses</h1>
          <div class="divider">
            <div class="zigzag clearfix "  data-svg-drawing="yes" >
              <svg xml:space="preserve" viewBox="0 0 69.172 14.975" width="37" height="28" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1">
                <path d="M1.357,12.26 10.807,2.81 20.328,12.332
                  29.781,2.879 39.223,12.321 48.754,2.79 58.286,12.321 67.815,2.793 "  style="stroke-dasharray: 93.9851, 93.9851; stroke-dashoffset: 0;"/>
              </svg>
            </div>
          </div>
        </div>

        <app-article-content class="py-3">
          <div class="my-courses">
            <div class="flex-container p-4" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start start" fxLayoutWrap="wrap">
              <ng-container *ngIf="courses">
                <app-course *ngFor="let course of courses" [course]="course" fxFlex="33%" fxFlex.sm="50%" class="w-100"></app-course>
              </ng-container>
            </div>
          </div>
        </app-article-content>

  </mat-card>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-courses/user-courses.component.html